module.exports = __webpack_public_path__ + "img/InDesign.0d2eff7a.png";